/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * All slick configs listed here so this file can be included at
 * any route and various Slick instances can be modified after init
 */

const slickConfig = {
  profileWork: {
    selector: 'section.profile-work .carousel',
    options: {
      dots: true,
      infinite: false,
      draggable: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"><svg class="icon icon-arrow"><use xlink:href="#icon-arrow"></use></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"><svg class="icon icon-arrow"><use xlink:href="#icon-arrow"></use></svg></button>',
    },
  },
  profileWorkModal: {
    selector: 'section.profile-work-modal .carousel',
    options: {
      dots: true,
      infinite: false,
      draggable: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: false,
      variableWidth: false,
      fade: true,
      cssEase: 'linear',
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"><svg class="icon icon-arrow"><use xlink:href="#icon-arrow"></use></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"><svg class="icon icon-arrow"><use xlink:href="#icon-arrow"></use></svg></button>',
    },
  },
}

export default slickConfig;

